import { render, staticRenderFns } from "./ParamNacionalidade.vue?vue&type=template&id=d7d33d88"
import script from "./ParamNacionalidade.vue?vue&type=script&lang=js"
export * from "./ParamNacionalidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports